import axios from 'axios'
const API = axios.create({baseURL: `https://fullrange-api.petrongsoftware.com/api/user`});
// const API = axios.create({baseURL: `http://localhost:8000/api/user`});

export const getBioDaata = (id) => API.get(`/clients/${id}`)
export const getAccountInfo = (id) => API.get(`/accountInfo/${id}`)
export const getEmployeeInfo = (id) => API.get(`/employeeInfo/${id}`)

export const loginUser = (formData) => API.post(`/login`, formData)
export const registerUser = (formData) => API.post(`/register`, formData)